module.exports = __webpack_public_path__ + "static/media/3. Geomorfos. Resina cristal.130 x 74 x 2 cm.2021 copy.61f0fdb7.png";